$(document).ready(function() {

// BFCM
$('#shopify-section-template--17002659283171__featured-collection .section__header a').attr('href','/collections/black-friday-cyber-monday');
$('#shopify-section-template--17002659283171__featured_collection_7Qg7kF .section__header a').attr('href','/collections/black-friday-cyber-monday');
$('#shopify-section-template--17002659283171__featured_collection_kzRzEn .section__header a').attr('href','/collections/black-friday-cyber-monday');
$('#shopify-section-template--17002659283171__promo_strip_nVbbxm').append('<img id="bfcm-receipt" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/BFCM-herobanner.png?v=1729745123" />')
  
$('#shopify-section-template--18106306199779__custom-collection-products-1 .grid').eq(0).prepend(`<div class="bfcm-collection-title"><h2>BEST SELLERS</h2></div><div></div><div></div><div></div>`);
$('#shopify-section-template--18106306199779__custom-collection-products-1 .js-pagination-result').eq(3).after(`<div class="bfcm-collection-title"><h2>NEW ARRIVALS</h2></div><div></div><div></div><div></div>`);
$('#shopify-section-template--18106306199779__custom-collection-products-1 .js-pagination-result').eq(11).after(`<div class="bfcm-collection-title"><h2>POPULAR ITEMS</h2></div><div></div><div></div><div></div>`);

$('#shopify-section-template--18106306199779__custom-collection-products-2 .grid').eq(0).prepend(`<div class="bfcm-collection-title"><h2>TREADMILLS</h2></div><div></div><div></div><div></div>`); 
$('#shopify-section-template--18106306199779__custom-collection-products-2 .js-pagination-result').eq(3).after(`<div class="bfcm-collection-title"><h2>ELLIPTICALS</h2></div><div></div><div></div><div></div>`); 
$('#shopify-section-template--18106306199779__custom-collection-products-2 .js-pagination-result').eq(9).after(`<div></div><div></div><div class="bfcm-collection-title"><h2>BIKES</h2></div><div></div><div></div><div></div>`); 
$('#shopify-section-template--18106306199779__custom-collection-products-2 .js-pagination-result').eq(15).after(`<div></div><div></div><div class="bfcm-collection-title"><h2>CLIMBMILLS</h2></div><div></div><div></div><div></div>`); 

// BOXING DAY
// BEST SELLER/NEW ARRIVAL/POPULAR TAB
$('#shopify-section-template--18261458125027__featured_collection_wa9hgw').hide();
$('#shopify-section-template--18261458125027__featured_collection_KpJHjz').hide();
$('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').eq(0).addClass('selected');
$('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').attr('style','border-bottom: none');
  $(this).attr('style','border-bottom: 3px solid black');
});

$('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').eq(0).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').eq(0).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_p33Aq3').show();
  $('#shopify-section-template--18261458125027__featured_collection_wa9hgw').hide();
  $('#shopify-section-template--18261458125027__featured_collection_KpJHjz').hide();
});
$('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').eq(1).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').eq(1).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_p33Aq3').hide();
  $('#shopify-section-template--18261458125027__featured_collection_wa9hgw').show();
  $('#shopify-section-template--18261458125027__featured_collection_KpJHjz').hide();
});
$('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').eq(2).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_FWkVnN .icons-with-text__text').eq(2).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_p33Aq3').hide();
  $('#shopify-section-template--18261458125027__featured_collection_wa9hgw').hide();
  $('#shopify-section-template--18261458125027__featured_collection_KpJHjz').show();
});

// MATRIX HOME CARDIO TAB
$('#shopify-section-template--18261458125027__featured_collection_K73j4A').hide();
$('#shopify-section-template--18261458125027__featured_collection_J3rH8Q').hide();
$('#shopify-section-template--18261458125027__featured_collection_ybdFXa').hide();
$('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(0).addClass('selected');
$('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').attr('style','border-bottom: none');
  $(this).attr('style','border-bottom: 3px solid black');
});

$('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(0).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(0).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_TCEziw').show();
  $('#shopify-section-template--18261458125027__featured_collection_K73j4A').hide();
  $('#shopify-section-template--18261458125027__featured_collection_J3rH8Q').hide();
  $('#shopify-section-template--18261458125027__featured_collection_ybdFXa').hide();
});
$('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(1).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(1).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_TCEziw').hide();
  $('#shopify-section-template--18261458125027__featured_collection_K73j4A').show();
  $('#shopify-section-template--18261458125027__featured_collection_J3rH8Q').hide();
  $('#shopify-section-template--18261458125027__featured_collection_ybdFXa').hide();
});
$('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(2).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(2).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_TCEziw').hide();
  $('#shopify-section-template--18261458125027__featured_collection_K73j4A').hide();
  $('#shopify-section-template--18261458125027__featured_collection_J3rH8Q').show();
  $('#shopify-section-template--18261458125027__featured_collection_ybdFXa').hide();
});
$('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(3).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_zFVCJJ .icons-with-text__text').eq(3).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_TCEziw').hide();
  $('#shopify-section-template--18261458125027__featured_collection_K73j4A').hide();
  $('#shopify-section-template--18261458125027__featured_collection_J3rH8Q').hide();
  $('#shopify-section-template--18261458125027__featured_collection_ybdFXa').show();
});

// MATRIX COMMERCIAL CARDIO TAB
$('#shopify-section-template--18261458125027__featured_collection_dxzzGX').hide();
$('#shopify-section-template--18261458125027__featured_collection_WCK6U6').hide();
$('#shopify-section-template--18261458125027__featured_collection_mYqQtV').hide();
$('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(0).addClass('selected');
$('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').attr('style','border-bottom: none');
  $(this).attr('style','border-bottom: 3px solid black');
});

$('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(0).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(0).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_qzyjgi').show();
  $('#shopify-section-template--18261458125027__featured_collection_dxzzGX').hide();
  $('#shopify-section-template--18261458125027__featured_collection_WCK6U6').hide();
  $('#shopify-section-template--18261458125027__featured_collection_mYqQtV').hide();
});
$('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(1).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(1).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_qzyjgi').hide();
  $('#shopify-section-template--18261458125027__featured_collection_dxzzGX').show();
  $('#shopify-section-template--18261458125027__featured_collection_WCK6U6').hide();
  $('#shopify-section-template--18261458125027__featured_collection_mYqQtV').hide();
});
$('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(2).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(2).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_qzyjgi').hide();
  $('#shopify-section-template--18261458125027__featured_collection_dxzzGX').hide();
  $('#shopify-section-template--18261458125027__featured_collection_WCK6U6').show();
  $('#shopify-section-template--18261458125027__featured_collection_mYqQtV').hide();
});
$('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(3).on('click', function () {
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').removeClass('selected');
  $('#shopify-section-template--18261458125027__icons_with_text_BTbddC .icons-with-text__text').eq(3).addClass('selected');
  $('#shopify-section-template--18261458125027__featured_collection_qzyjgi').hide();
  $('#shopify-section-template--18261458125027__featured_collection_dxzzGX').hide();
  $('#shopify-section-template--18261458125027__featured_collection_WCK6U6').hide();
  $('#shopify-section-template--18261458125027__featured_collection_mYqQtV').show();
});
  
$('.product-label-container .product-label').each(function() {
  if ($(this).text().includes('OFF') || $(this).text().includes('PRE-ORDER')) {
  	$(this).attr('style','border-radius: 25px !important; background-color: #B40C1C; color: white!important; font-weight: 600; font-size: 14px; margin: 5px;');
    $(this).parent().siblings().remove();
  }
});
$('.pagination--modern').on('click', function() {
  setTimeout(function() {
  	$('.product-label-container .product-label').each(function() {
	  if ($(this).text().includes('OFF') || $(this).text().includes('PRE-ORDER')) {
	  	$(this).attr('style','border-radius: 25px !important; background-color: #B40C1C; color: #white!important; margin: 5px;');
	    $(this).parent().siblings().remove();
	  }
	});
  }, 1000);
});

  
// HALLOWEEN HOMEPAGE
$('#homepage #template--17002659283171__image_banner_nHnz4C').append('<img id="cobweb" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/9296250_1.png?v=1729056785" />')
// $('#homepage #shopify-section-template--17002659283171__featured-collection').append('<img id="cobweb-1" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/9296250.png?v=1729040763" />')
$('#homepage #shopify-section-template--17002659283171__promo_strip_nVbbxm').append('<img id="cobweb-2" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/9296298.png?v=1729057735" />')
$('#homepage #shopify-section-template--17002659283171__promo_strip_nVbbxm').append('<img id="cobweb-spider" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/picmix.com_2351879_336eca54-86f5-41cc-b3a2-63872a344df4.gif?v=1728969333" />')
$('#homepage #slider-template--17002659283171__featured-collection .slider__item').eq(0).find('a').eq(0).append('<img class="skeleton" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/Screenshot_2024-10-15_162344_2.png?v=1728969918" />')
$('#homepage #slider-template--17002659283171__featured-collection .slider__item').eq(1).find('a').eq(0).append('<img class="skeleton-1" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/Screenshot_2024-10-15_162344_2_1.png?v=1729048492" />')
$('#homepage #slider-template--17002659283171__featured-collection .slider__item').eq(2).find('a').eq(0).append('<img class="skeleton" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/Screenshot_2024-10-15_162344_2.png?v=1728969918" />')
$('#homepage #slider-template--17002659283171__featured-collection .slider__item').eq(3).find('a').eq(0).append('<img class="skeleton-1" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/Screenshot_2024-10-15_162344_2_1.png?v=1729048492" />')
$('#homepage #slider-template--17002659283171__featured-collection .slider__item').eq(4).find('a').eq(0).append('<img class="skeleton" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/Screenshot_2024-10-15_162344_2.png?v=1728969918" />')
$('#homepage #slider-template--17002659283171__featured-collection .slider__item').eq(5).find('a').eq(0).append('<img class="skeleton-1" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/Screenshot_2024-10-15_162344_2_1.png?v=1729048492" />')
$('#homepage #slider-template--17002659283171__featured-collection .slider__item').eq(6).find('a').eq(0).append('<img class="skeleton" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/Screenshot_2024-10-15_162344_2.png?v=1728969918" />')
$('#homepage #slider-template--17002659283171__featured-collection .slider__item').eq(7).find('a').eq(0).append('<img class="skeleton" src="https://cdn.shopify.com/s/files/1/0252/9335/7102/files/Screenshot_2024-10-15_162344_2.png?v=1728969918" />')
  
  $(".cc-product-comparison-grid").appendTo("#Comparison");
  
  $(".finance-available-btn").parents('.product-info__block').css("margin", "0");
  $(".buy-now-pay-later").parents('.product-info__block').css("margin-bottom", "0");

  // HOMEPAGE PRODUCT CAROUSEL
  $(".carousel-btn.left").on("click", function() {
    var leftPos = $(this).closest(".shopify-section").find(".section .slider").scrollLeft();
    $(this).closest(".shopify-section").find(".section .slider").animate({scrollLeft: leftPos - 200});
    console.log(leftPos);
  });
  $(".carousel-btn.right").on("click", function() {
    var rightPos = $(this).closest(".shopify-section").find(".section .slider").scrollLeft();
    $(this).closest(".shopify-section").find(".section .slider").animate({scrollLeft: rightPos + 200});
    console.log(rightPos);
  });
  // PRODUCT PAGE FEATURE
  $(".hotspot__card").each(function(index) {
    if(!$(this).has('.rte').length) {
      $(this).closest(".hotspot").hide();
    }
  });
  $('#delivery-calculator input').keypress(function(e){
    if(e.keyCode==13)
    $('#delivery-calculator button').click();
  });

  $("#shopify-section-template--17164370673891__image_banner_YLdPEq .btn").on("click", function() {
    console.log(123);
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#template--17164370673891__rich_text_g8iBhx").offset().top
    }, 800);
  });

  // MOTHERS DAY LANDING PAGE
  $("#shopify-section-template--17452596265187__custom-collection-products-1 .product-label--sale").html("Mother's Day Gift Idea");
  $("#shopify-section-template--17452596265187__custom-collection-products-2 .product-label--sale").html("Mother's Day Gift Idea");
  $("#shopify-section-template--17452596265187__custom-collection-products-1 .product-label--sale").css("background-color","#ffdde3");
  $("#shopify-section-template--17452596265187__custom-collection-products-2 .product-label--sale").css("background-color","#ffdde3");
  $("#shopify-section-template--17452596265187__custom-collection-products-1 .product-label--sale").css("color","black");
  $("#shopify-section-template--17452596265187__custom-collection-products-2 .product-label--sale").css("color","black");

  // COMMERCIAL GYM ENQUIRY
    // var commercial_gym_enquiry_banner_1 = $("#shopify-section-template--17573192564963__icons_with_text_4rEm3g").offset().top;
    // var commercial_gym_enquiry_banner_2 = $("#shopify-section-sections--17002659741923__footer").offset().top - 800;
    // if ($(window).width() > 768) {
    //   var $w = $(window).scroll(function(){
    //       if ( $w.scrollTop() > commercial_gym_enquiry_banner_1 && $w.scrollTop() < commercial_gym_enquiry_banner_2 ) {
    //         $("#shopify-block-forms_inline_dBnEQQ").fadeIn(250);
    //       } else {
    //         $("#shopify-block-forms_inline_dBnEQQ").fadeOut(250);
    //       };
    //       if ( $w.scrollTop() > commercial_gym_enquiry_banner_2 ) {
    //         $("#shopify-block-forms_inline_dBnEQQ").fadeOut(250);
    //       }
    //   });
    // }
});

// Place modal pop-up function.

document.addEventListener('DOMContentLoaded', () => {
  function bindGetBestPriceButtons() {
    document.querySelectorAll('.get-best-price-btn').forEach(button => {
      button.removeEventListener('click', handleModalOpen); // Ensure no duplicates
      button.addEventListener('click', handleModalOpen);
    });
  }

  function handleModalOpen(e) {
    const modal = document.getElementById('enquire-global-modal');
    if (!modal) return;

    const title = e.currentTarget.getAttribute('data-product-title');
    const id = e.currentTarget.getAttribute('data-product-id');

    // Fill dynamic fields
    document.getElementById('enquire-product-title').value = title || '';
    document.getElementById('enquire-product-id').value = id || '';

    modal.classList.add('show');
    document.body.classList.add('modal-open');

    const overlay = modal.querySelector('.modal-overlay');
    const closeBtn = modal.querySelector('.modal-close');
    const form = modal.querySelector('form');

    function closeModal() {
      modal.classList.remove('show');
      document.body.classList.remove('modal-open');
    }

    overlay?.addEventListener('click', closeModal);
    closeBtn?.addEventListener('click', closeModal);

    form?.addEventListener('submit', function(e) {
      const phone = form.querySelector('input[name="contact[phone]"]');
      const pattern = /^(\+?61|0)4\d{8}$/;
      if (!pattern.test(phone.value)) {
        e.preventDefault();
        alert('Please enter a valid Australian mobile number.');
        phone.focus();
      }
    });
  }

  // Run once initially
  bindGetBestPriceButtons();

  // Observe DOM mutations for dynamic product renders (sliders, pagination, recommendations)
  const observer = new MutationObserver(() => {
    bindGetBestPriceButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Make available globally
  window.bindGetBestPriceButtons = bindGetBestPriceButtons;
});
